import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// LEAD MANAGEMENT APIS
// ================================

// 🔹 Get Leads (with pagination, search, filter by user)
export async function getLeads(lead_user, page_no = 0, search_key = "",lead_status="",lead_website="") {
  try {
    const fd = new FormData();
    fd.append("lead_user", lead_user);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);
    fd.append("lead_status", lead_status);
    fd.append("lead_website", lead_website);

    const response = await axios.post(`${apiBaseUrl}lead/get_leads`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getLeads error:", error);
    return { status: false, type: "danger", success: "Failed to fetch leads" };
  }
}

// 🔹 Get Lead Report (total, today, pending, closed)
export async function getLeadReport(lead_user,lead_status="",lead_website="") {
  try {
    const fd = new FormData();
    fd.append("lead_user", lead_user);
    fd.append("lead_status", lead_status);
    fd.append("lead_website", lead_website);

    const response = await axios.post(`${apiBaseUrl}lead/get_lead_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getLeadReport error:", error);
    return { status: false, type: "danger", success: "Failed to load lead report" };
  }
}

// 🔹 Delete Lead
export async function deleteLead(lead_id) {
  try {
    const fd = new FormData();
    fd.append("lead_id", lead_id);

    const response = await axios.post(`${apiBaseUrl}lead/delete_lead`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteLead error:", error);
    return { status: false, type: "danger", success: "Delete request failed" };
  }
}

// 🔹 Update Lead Status
export async function updateLeadStatus(lead_id, lead_status) {
  try {
    const fd = new FormData();
    fd.append("lead_id", lead_id);
    fd.append("lead_status", lead_status);

    const response = await axios.post(`${apiBaseUrl}lead/update_lead_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateLeadStatus error:", error);
    return { status: false, type: "danger", success: "Lead status update failed" };
  }
}

export async function exportLeads(lead_user) {
  try {
    const params = new URLSearchParams();
    if (lead_user) {
      params.append("lead_user", lead_user);
    }

    const url = `${apiBaseUrl}lead/export_leads?${params.toString()}`;

    alert(url+"");

    // Trigger browser download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "leads_export.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { status: true, type: "success", success: "Leads exported successfully" };
  } catch (error) {
    console.error("exportLeads error:", error);
    return { status: false, type: "danger", success: "Failed to export leads" };
  }
}

